<ion-header [translucent]="true">
  <ion-toolbar>
      <ion-title class="ion-text-center">
          {{"ORDENES" | translate}}
      </ion-title>

      <ion-buttons slot="start">
        <ion-back-button text="{{'BACK_BUTTON' | translate}}" defaultHref="/tabs/tab1"></ion-back-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button (click)="_cs.ver_carrito()">
            <ion-icon slot="icon-only" name="cart"></ion-icon>
            <ion-badge *ngIf="_cs.itemsCarrito.length > 0"  class="carrito_numero" color="danger">{{ _cs.itemsCarrito.length }}</ion-badge>
        </ion-button> &nbsp; &nbsp;
      </ion-buttons>
  </ion-toolbar>

  <ion-toolbar *ngIf="_us.nombreCia">
    <ion-img class="img-logoCia" [src]="_us.logoCia | image:'X'" *ngIf="_us.logoCia"> {{ _us.nombreCia }}</ion-img>
  </ion-toolbar>

  <ion-toolbar *ngIf="_us.activo()">
    <ion-title class="ion-text-center">
      {{ _us.usuario.username }}
     </ion-title>
    <ion-icon slot="end" (click)="_us.cerrar_sesion()" name="log-out-outline"></ion-icon>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding">

  <div class="carrito_vacio ion-text-center" *ngIf="_cs.ordenes.length === 0">
    <ion-icon class="icon-5x" name="cart-outline"></ion-icon>
    <br> {{ "NO_ORDENES_ABIERTAS" | translate}}
  </div>


  <ion-list *ngIf="_cs.ordenes.length > 0">
      <ion-item button detail="true" *ngFor="let orden of _cs.ordenes" [routerLink]="['/ordenes-detalle', orden.id ]">
        <ion-label class="ion-text-justify">
          <h3><strong>{{"ORDER" | translate}} ID: </strong> {{ orden.id }}</h3>
          <p>
            {{ orden.strNombreCliente }}
          </p>
          <p>
          <ion-icon slot="start" name="cash"></ion-icon>
            {{ orden.detalle[0].totalOrden | currency:'USD':'symbol':'1.2-2' }}
          </p>

        </ion-label>
      </ion-item>

  </ion-list>

</ion-content>
